
function  SellerPofile  ()  {

    return(
        <>
            
        </>
    );
}

export default SellerPofile;
